import axios from 'axios'

export default {
    download(filter) {
        return axios.download('/api/resolutioncodes/export',
            {
                productId: filter.productId,
                categoryId: filter.categoryId,
                description: filter.text,
                code: filter.text
            });
    },
    getCodes(page, productId, categoryId, text) {
        return axios.get('/api/resolutioncodes/table',
            {
                params: {
                    page: page,
                    productId: productId,
                    categoryId: categoryId,
                    description: text,
                    code: text
                }
            });
    },
    getCode(id) {
        return axios.get(`/api/resolutioncodes/table/${id}`);
    },
    saveCode(id, code) {
        if (id) {
            return axios.put(`/api/resolutioncodes/${id}`, code);
        }
        return axios.post('/api/resolutioncodes', code);
    },
    deleteCode(id) {
        return axios.delete(`/api/resolutioncodes/${id}`);
    },
    // downloadCategories(filter) {
    //     return axios.download('/api/resolutioncodecategories/export',
    //         {
    //             productId: filter.productId,
    //             name: filter.text,
    //             description: filter.text
    //         });
    // },
    getCategories(page, productId, text) {
        return axios.get('/api/resolutioncodecategories/table',
            {
                params: {
                    page: page,
                    productId: productId,
                    name: text,
                    description: text
                }
            });
    },
    getCategory(id) {
        return axios.get(`/api/resolutioncodecategories/${id}`);
    },
    saveCategory(id, category) {
        if (id) {
            return axios.put(`/api/resolutioncodecategories/${id}`, category);
        }
        return axios.post('/api/resolutioncodecategories', category);
    },
    deleteCategory(id) {
        return axios.delete(`/api/resolutioncodecategories/${id}`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/resolutioncodes/api.js